/* ErrorMessage.ts */

export const ErrorMessage = {
  NO_CONTENT: "No Content",
  BAD_REQUEST: "Bad Request",
  UNEXPECTED_ERROR: "An unexpected error occured",
  INTERNAL_SERVER_ERROR: "Internal Server Error",
  MAIN_CONDITION_NOT_FOUND: "Disease not found",
  INVALID_CREDENTIALS: "Invalid credentials",
  TWO_FA_REQUIRED: "Two-Factor Authentication Required",
  INVALID_CODE: "Invalid code",
  NO_CARE_SITE_ACCESS:
    "No care site access configured for your account. Please contact your administrator.",
  NO_AGENT_ACCESS:
    "You do not have access to the AI Assistant. Please contact your administrator.",
  AGENT_UNAVAILABLE:
    "The AI Assistant is currently not available.",
  AGENT_VERSION_MISMATCH:
    "The AI Assistant has been updated. Please reload the page.",
};

export const InputErrorMessage = {
  DUPLICATE_NAME: "Name already exists",
  MIN_LENGTH: "Name must be at least 3 characters",
};
